import './styles.scss';

import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import CMSLink from 'media-base-ui/views/components/cmsLink';

import { leadStoryOperations } from '../../../redux/ducks/leadStory';
import VideoComponent from '../videoComponent';

const sendGaClickEvent = isVideoToggle => {
    window.dataLayer.push({
        event: 'click',
        'event_category': 'Lead Story Component',
        'event_label': isVideoToggle ? 'video toggle' : 'read more'
    });
};

const LeadStory = (props) => {
    const leadStory = useSelector(({ leadStory }) => leadStory.leadStoryState);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(leadStoryOperations.fetchLeadStoryData());
    }, []);

    return Object.keys(leadStory).length > 0
        ?
            <div className="lead-module-container">
                { leadStory.videoId !== 0 && leadStory.videoId !== null
                    ?
                        <VideoComponent
                            videoId={leadStory.videoId}
                            imageUrl={leadStory.imageUrl}
                            altText={leadStory.keywords}
                            onClick={sendGaClickEvent.bind(this, true)}
                        />
                    :
                        <CMSLink
                            url={leadStory.destinationUrl}
                            target={leadStory.linkTarget || '_blank'}
                            onClick={sendGaClickEvent.bind(this, false)}>
                                <img src={leadStory.imageUrl} alt={leadStory.keywords}/>
                        </CMSLink>
                }

                <div className="photo-credit">
                    {leadStory.photoCredit && `Photo Credit: ${leadStory.photoCredit}`}
                </div>

                <div className="tray">
                    <CMSLink
                        url={leadStory.destinationUrl}
                        target={leadStory.linkTarget || '_blank'}
                        onClick={sendGaClickEvent.bind(this, false)}>
                            <h1>{leadStory.headline}</h1>
                    </CMSLink>
                    <p>{leadStory.teaser}</p>
                    <CMSLink
                        url={leadStory.destinationUrl}
                        target={leadStory.linkTarget || '_blank'}
                        onClick={sendGaClickEvent.bind(this, false)}>
                            <p>Read More</p>
                    </CMSLink>
                </div>
            </div>
        :   null
};

export default LeadStory;
